'use client';
import { useRouter } from 'next/navigation';
import { Icon } from '../Icon';
import { useHoverPreview } from './HoverPreview';

/**
 * 상품 썸네일 — 가이드 `course-thumb`.
 *
 * **`<a>` 가 아니라 `<div>` 다.** 가이드가 그렇고, 그래야 CSS 가 맞는다 —
 * `.course-thumb{width:100%; aspect-ratio:4/3}` 는 인라인 요소(`<a>`)에서는 먹지 않아
 * 썸네일이 찌그러진다. 또 안에 맛보기·관련교재 `<a>` 가 들어가므로 `<a>` 안의 `<a>` 가
 * 되어 브라우저가 구조를 임의로 갈라 버린다.
 *
 * 그래서 가이드처럼 눌러서 이동한다(`onclick="location.href=…"`).
 * 제목에는 진짜 `<a>` 가 있으므로 크롤러·키보드 이동은 그쪽이 맡는다.
 */
export function Thumb({ image, name, href, className = 'course-thumb', previewCcid, previewDelay, children }: {
  image: string | null;
  name: string;
  href: string;
  /**
   * 상자 클래스 — 가이드가 자리마다 다른 이름을 쓴다(2026-08-26 개정).
   * 강좌는 카드·리스트 모두 `course-thumb`, **교재 리스트만 `clist-thumb`** 다.
   * 크기 규칙(`.clist-item .course-thumb, .clist-item .clist-thumb`)은 둘을 함께 잡지만,
   * 이미지 모서리 규칙이 갈리므로 이름을 가이드와 같게 둔다.
   */
  className?: string;
  /**
   * 호버 미리보기를 쓸 차시(맛보기 0번째). **설정이 켜졌을 때만** 넘어온다 —
   * 값이 없으면 훅이 아무 일도 하지 않아 예전과 똑같이 동작한다.
   */
  previewCcid?: number;
  /** 여는 데 필요한 머무름(ms) — 비우면 기본값. /ux-lab 이 재 보는 데만 쓴다 */
  previewDelay?: number;
  children?: React.ReactNode;
}) {
  const router = useRouter();
  const preview = useHoverPreview(previewCcid, previewDelay);
  return (
    <div className={className} onClick={() => router.push(href)} {...preview.bind}>
      {image
        ? <img src={image} alt={name} />
        : <div className="course-no-img"><Icon name="image" /></div>}
      {children}
      {preview.node}
    </div>
  );
}
